import {MOBILE_DISPLAY_STATE} from "./detailsSheetContext";

export const isStateClosed = (state) => MOBILE_DISPLAY_STATE.CLOSED === state;

export const isStateMenuOpen = (state) => MOBILE_DISPLAY_STATE.MENU_OPEN === state;

export const isStateShopsOpen = (state) => MOBILE_DISPLAY_STATE.SHOP_LIST_OPEN === state;

export const isShopsFetched = (state) =>
    !state.shopsQueryState?.isLoading
    && !state.shopsQueryState?.error
    && !state.shopsQueryState?.isFetching
    && state.shopsQueryState?.data?.length

export const isAbleToFetchShops = (state) => {
    return !!state.shopsQueryParams?.lat
        && !!state.shopsQueryParams?.long
        && !!state.shopsQueryParams?.formula
}
